import { forwardRef, useMemo, createElement, createContext, useContext, isValidElement } from 'react';
import cn from 'classnames';
import { Root, Trigger as Trigger$1, Close as Close$1 } from '@radix-ui/react-popover';
import { UnstyledContent, UnstyledArrow } from './Primitives.js';
import { mergeRefs } from '../../utils/mergeRefs.js';

const PopoverContext = /*#__PURE__*/createContext({
  props: {},
  ref: null
});
const Trigger = /*#__PURE__*/forwardRef(function PopoverTrigger(props, ref) {
  var _props$children;

  const context = useContext(PopoverContext);
  let children = props.children;

  if (isValidElement(props.children) && typeof ((_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.type) === 'function') {
    console.warn(`Popover.Trigger requires its child to forwardRef so that it can attach to the dom element. Did you mean to wrap '${props.children.type.name}' in React.forwardRef()? Taco has wrapped '${props.children.type.name}' in a 'span' to maintain functionality, but this may cause unintended behaviour`);
    children = createElement("span", null, props.children);
  }

  return createElement(Trigger$1, Object.assign({}, context.props, props, {
    children: children,
    ref: mergeRefs([context.ref, ref]),
    asChild: true
  }));
});
const RenderPropWrapper = /*#__PURE__*/forwardRef(function RenderPropWrapper({
  children,
  onClick
}, ref) {
  const close = () => {
    onClick(new CustomEvent('hide'));
  };

  return children({
    close,
    ref
  });
});
const Content = /*#__PURE__*/forwardRef(function PopoverContent(props, ref) {
  const className = cn('bg-white focus:border-blue-light', props.className);
  let output;

  if (typeof props.children === 'function') {
    output = createElement(Close$1, {
      asChild: true
    }, createElement(RenderPropWrapper, null, props.children));
  } else {
    output = props.children;
  }

  return createElement(UnstyledContent, {
    className: className,
    placement: props.placement,
    ref: ref
  }, output, createElement(UnstyledArrow, {
    className: "text-white"
  }));
});
const Close = /*#__PURE__*/forwardRef((props, ref) => createElement(Close$1, Object.assign({}, props, {
  ref: ref,
  asChild: true
})));
const Popover = /*#__PURE__*/forwardRef(function Popover(props, ref) {
  const {
    children,
    trigger,
    ...otherProps
  } = props;
  const context = useMemo(() => ({
    props: otherProps,
    ref
  }), [otherProps]);
  return createElement(PopoverContext.Provider, {
    value: context
  }, createElement(Root, null, trigger && createElement(Trigger, null, trigger), children));
});
Popover.Trigger = Trigger;
Popover.Content = Content;
Popover.Close = Close;

export { Popover };
//# sourceMappingURL=Popover.js.map
